import { IMarketplaceTable, marketplaceListAction, MARKETPLACE_ENUM } from 'app/configs/marketplaceList.config';
import { IMarketplaceList } from 'app/interfaces/marketplace/marketplace.interface';
import { ITextLabel } from 'app/interfaces/text-label/textLabel.interface';
import { RootState } from 'app/redux/store';
import { toast } from 'react-toastify';
import { marketplaceDownloadFactsheetAction, getTNCPrivacyPolicy } from 'app/redux/actions/MarketplaceListAction';
import ImagePath from 'app/utilities/imagePath';
import useComponentVisible from 'app/utils/VisibleComponent';
import customModalStyles from 'config/modal.config';
import modalDocument from 'config/modalDocument.config';
import React, { ChangeEvent, ReactElement, useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import rupiahCurrencyFormatter from 'app/utils/RupiahPipe';
import InterestConverter from 'app/utils/InterestConverter';
import { ISubmitFundingPayload,
		submitFundingAction,
		getLoanAgreementDocumentAction,
		downloadAgrementPDFAction,
		resetAgreementPDFAction,
		resetLoanAgreementDocumentAction,
        downloadLenderAgrementPDFAction
    } from 'app/redux/actions/FundingAction';
import Modal from 'react-modal';
import Toggle from 'react-toggle';
import Button from '../Button/Button';
import FundingProgressBar from '../FundingProgressBar/FundingProgressBar';
import InputComponent from '../InputComponent/InputComponent';
import ShimmeringLoading from '../ShimmeringLoading/ShimmeringLoading';
import TextLabel from '../TextLabel/TextLabel';
import './MarketplaceCard.scss';

interface MarketplaceCardProps {
    marketplaceTextLabel: IMarketplaceTable
}

const initSelectedItem: IMarketplaceTable = {
    data: {} as IMarketplaceList,
    textLabel: [] as ITextLabel[]
};

const MarketplaceCard = function init(props: MarketplaceCardProps): React.ReactElement {
    const {
        marketplaceTextLabel
    } = props;

    const dispatch = useDispatch();
    const marketplaceListState = useSelector((state: RootState) => state.marketplaceListReducer);
    const fundingState = useSelector((state: RootState) => state.fundingReducer);
    const { fundingLoading, urlLoanAgreement, agreementBase64, urlLenderAgreement, lenderAgreementBase64 } = fundingState;
    const { loading, dataTNCPrivacyPolicy } = marketplaceListState;
    const [isModalFundingOpen, setModalFundingOpen] = useState(false);
	const [isModalAgreementOpen, setModalAgreementOpen] = useState(false);
	const [disableButtonAgreement, setDisableButtonAgreement] = useState(true);
	const [disableCheckBoxAgreement, setDisableCheckboxAgreement] = useState(true);
    const [activeTab, setActiveTab] = useState('ppfp');
    const [selectedItem, setSelectedItem] = useState(initSelectedItem);
    const [selectedItemFunding, setSelectedItemFunding] = useState(initSelectedItem);
    const portofolioState = useSelector((state: RootState) => state.portofolioReducer);
    const { lenderSummary } = portofolioState;
    const [invalid, setInvalid] = useState(true);
    const [isFullFunding, setFullFunding] = useState(false);
	const [dataTnc, setDataTnc] = useState('');
    const [form, setForm] = useState([
        {
            id: 'fundingAmount',
            formType: 'currency',
            placeholder: 'Jumlah Funding',
            name: 'fundingAmount',
            apiErrorMessage: '',
            value: '',
            disabled: false
        },
    ]);

    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    useEffect(() => {
        const tempForm = [...form];
        const fundingInput = tempForm[0];
        const field = {
            name: fundingInput.name,
            value: fundingInput.value
        };
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        onChangeHandle(field);
    }, [isFullFunding]);

	useEffect(() => {
		if (agreementBase64 && isModalFundingOpen && lenderAgreementBase64) {
			setModalAgreementOpen(true);
		}
	}, [agreementBase64, isModalFundingOpen, lenderAgreementBase64]);

	useEffect(() => {
		if (dataTNCPrivacyPolicy) {
			setDataTnc(dataTNCPrivacyPolicy[0]?.description);
		}
	}, [dataTNCPrivacyPolicy]);

	function handleTnc(): void {
		const wnd = window.open("about:blank", "", "_blank");
		if (wnd && dataTnc) {
			wnd.document.write(dataTnc);
			wnd.document.title = "Syarat & Ketentuan";
			// eslint-disable-next-line func-names
			wnd.onscroll = function () {
				if ((wnd.window.innerHeight + Math.round(wnd.window.scrollY)) >= wnd.document.body.offsetHeight) {
					setDisableCheckboxAgreement(false);
				}
			};
		}
	}

	useEffect(() => {
		if (urlLoanAgreement) {
		try {
			dispatch(downloadAgrementPDFAction({
				document_url: urlLoanAgreement
			}));
		} catch (err) {
			toast.error("Mohon maaf terjadi kesalahan. Coba beberapa saat lagi.");
			setModalFundingOpen(false);
			setModalAgreementOpen(false);
		}
		}
	}, [urlLoanAgreement]);

    useEffect(() => {
		if (urlLenderAgreement) {
		try {
			dispatch(downloadLenderAgrementPDFAction({
				document_url: urlLenderAgreement
			}));
		} catch (err) {
			toast.error("Mohon maaf terjadi kesalahan. Coba beberapa saat lagi.");
			setModalFundingOpen(false);
			setModalAgreementOpen(false);
		}
		}
	}, [urlLenderAgreement]);

    function renderTabComponent(): React.ReactElement {
        return (
            <div className="tab-wrapper">
                <button
                type="button"
                className={`tab ${activeTab === 'ppfp' ? 'active' : ''}`}
                onClick={() => setActiveTab('ppfp')}
                >
                    Perjanjian Pemberian Fasilitas Pendanaan
                </button>
                <button
                    type="button"
                    className={`tab ${activeTab === 'pp' ? 'active' : ''}`}
                    onClick={() => setActiveTab('pp')}
                >
                    Perjanjian Pendanaan
                </button>
            </div>
        );
    }

    function initFundingPopup(item: IMarketplaceTable): void {
        dispatch(resetAgreementPDFAction());
		dispatch(resetLoanAgreementDocumentAction());
		const totalLoanTextLabel: ITextLabel = {
            bg: false,
            title: "Jumlah Pinjaman",
            value: rupiahCurrencyFormatter(item.data.totalLoan),
        };
		const purposeLoanTextLabel: ITextLabel = {
			bg: false,
			title: "Keterangan Pinjaman",
			value: item.data.purposeLoan || '-'
		};
        const tempItem = Object.create(item);
        tempItem.textLabel = [
            ...tempItem.textLabel,
            totalLoanTextLabel,
			purposeLoanTextLabel
        ];
        setSelectedItem(item);
        setSelectedItemFunding(tempItem);
        setModalFundingOpen(true);
		setModalAgreementOpen(false);
    }

    function renderTextLabel(textLabel: ITextLabel, index: number): React.ReactElement {
        return (
            <div
                className="loan-textlabel"
                key={`textLbl-${index}`}
            // style={{ width: `${textLabel.width}%` }}
            >
                <TextLabel
                    bg={textLabel.bg}
                    title={textLabel.title}
                    value={textLabel.value}
                    loading={textLabel.loading ? textLabel.loading : loading}
                />
            </div>
        );
    }

    function renderPercentageLoanTypeText(
        interest: number,
        loanTypeName: string
    ): React.ReactElement {
        return (
            <>
                <span className="interest">
                    {`${InterestConverter(interest)}%`}
                </span>
                <div className="loan-type">
                    <span>
                        {loanTypeName}
                    </span>
                </div>
            </>
        );
    }

    function optionsButtonOnClick(id: number): void {
		const factsheet = marketplaceTextLabel.data.factsheetUrl;
        if (id === MARKETPLACE_ENUM.downloadFactsheet) {
            if (factsheet) {
                dispatch(marketplaceDownloadFactsheetAction({
                    document_url: factsheet
                }));
            }
        }
    }

	function renderPDWViewer() : ReactElement {
		const agreementStyling = {
			marginBottom: '36px',
			height: '500px',
			backgroundColor: '#F3F8FC',
			color: 'black'
		};
		let getUrlFromBlob;
		const removeToolbarPDF = '#toolbar=0&navpanes=0&scrollbar=0';
		if (lenderAgreementBase64 && activeTab === 'ppfp') {
			getUrlFromBlob = URL.createObjectURL(lenderAgreementBase64);
		}
        if (agreementBase64 && activeTab === 'pp') {
            getUrlFromBlob = URL.createObjectURL(agreementBase64);
        }
		return (
			<div className="previewAgreement" style={agreementStyling}>
			<object data={getUrlFromBlob + removeToolbarPDF} type="application/pdf" width="100%" height="100%">
				<p>
					<a href={getUrlFromBlob + removeToolbarPDF}>to the PDF!</a>
				</p>
			</object>
			</div>
		);
	}
    function renderFactsheetItem(): ReactElement {
        return (
            <div
                className="marketplaceAction"
                ref={ref}
            >
                {isComponentVisible && marketplaceListAction.map((each) => (
                    <div
                        role="button"
                        tabIndex={0}
                        onKeyPress={() => optionsButtonOnClick(each.id)}
                        key={each.label}
                        className="marketplaceListAction"
                        onClick={() => optionsButtonOnClick(each.id)}
                    >
                        {each.label}
                    </div>
                ))}
            </div>
        );
    }

    function renderTopContainer(item: IMarketplaceTable): React.ReactElement {
        return (
            <div className="top-container">
                {loading ? <ShimmeringLoading height={40} width={228} />
                    : renderPercentageLoanTypeText(
                        item.data.interestPercentage,
                        item.data.loanTypeName
                    )}
                {item.textLabel.map((each: ITextLabel, index: number) => (
                    renderTextLabel(each, index)
                ))}
                <button
                    className={`toggleButton ${loading ? "hide" : ""}`}
                    type="button"
                    onClick={() => setIsComponentVisible(!isComponentVisible)}
                >
                    <img
                        src={ImagePath.editDots.src}
                        alt={ImagePath.editDots.alt}
                    />
                    {renderFactsheetItem()}
                </button>
            </div>
        );
    }

    function renderFundingProgressBar(item: IMarketplaceTable): React.ReactElement {
        return (
            <FundingProgressBar
                progressPercentage={item.data.progressPercentage}
                totalLoan={item.data.totalLoan}
                outstandingFunding={item.data.outstandingFunding}
                dueDate={item.data.dueDate}
                loading={loading}
            />
        );
    }

    function renderBottomContainer(item: IMarketplaceTable): React.ReactElement {
        return (
            <div className={`bottom-container ${loading ? "loading" : ""}`}>
                <div className="loan-progress">
                    {renderFundingProgressBar(item)}
                </div>
                <div className="button-container">
                    {loading ? <ShimmeringLoading height={40} />
                        : (
                            <button
                                className="btn-fund"
                                type="button"
                                onClick={() => initFundingPopup(item)}
                            >
                                <div className="text">
                                    <img
                                        src={ImagePath.whitePlusIcon.src}
                                        alt={ImagePath.whitePlusIcon.alt}
                                    />
                                    <span>Danai</span>
                                </div>
                            </button>
                        )}
                </div>
            </div>
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onHandleSubmitFunding = useCallback((event: ChangeEvent<any>): void => {
        event.preventDefault();
		const val = form[0].value.split('.').join('');
		const getLenderUserId = localStorage.getItem('user');
		let userID = "";
		if (getLenderUserId) {
			const resp = JSON.parse(getLenderUserId);
			userID = resp.userId;
		}
		const payload = {
			loanNumber: selectedItem.data.loanNumber,
			lenderUserId: userID,
			amount: Number(val)
		};
		const payloadTNC = {
			category: 'TNC',
			key: 'GENERAL'
		};
		try {
			dispatch(getLoanAgreementDocumentAction(payload));
			dispatch(getTNCPrivacyPolicy(payloadTNC));
		} catch (err) {
			toast.error("Mohon maaf terjadi kesalahan. Coba beberapa saat lagi.");
			setModalFundingOpen(false);
			setModalAgreementOpen(false);
		}
    }, [selectedItem]);

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onHandleSubmitAgreement = useCallback((event: ChangeEvent<any>): void => {
        event.preventDefault();
        const val = form[0].value.split('.').join('');
        if (!fundingLoading) {
            const payload: ISubmitFundingPayload = {
                loanId: selectedItem.data.loanId,
                amount: Number(val),
                loanNumber: selectedItem.data.loanNumber
            };
			dispatch(submitFundingAction(payload));
			setDisableButtonAgreement(true);
			setDisableCheckboxAgreement(true);
        }
    }, [selectedItem, form]);

    function thousandSeparator(val: number): string {
        const res = val.toString().replace(/[^0-9]/g, "");
        return res.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    function onToggleChange(checked: boolean): void {
        const tempForm = [...form];
        const fundingInput = tempForm[0];
        if (checked) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            fundingInput.value = thousandSeparator(selectedItem.data.outstandingFunding);
            fundingInput.disabled = true;
            setForm(tempForm);
        } else {
            fundingInput.value = '';
            fundingInput.disabled = false;
            setForm(tempForm);
        }
        setFullFunding(checked);
    }

    function closeFundingModal(): void {
        const tempForm = [...form];
        const fundingInput = tempForm[0];
        fundingInput.apiErrorMessage = '';
        fundingInput.value = '';
        fundingInput.disabled = false;
        setFullFunding(false);
        setForm(tempForm);
        setModalFundingOpen(false);
		dispatch(resetAgreementPDFAction());
		dispatch(resetLoanAgreementDocumentAction());
    }

    function closeAgreementModal(): void {
        setDisableButtonAgreement(true);
        setModalAgreementOpen(false);
		setDisableCheckboxAgreement(false);
		dispatch(resetAgreementPDFAction());
		dispatch(resetLoanAgreementDocumentAction());
    }

    function onChangeHandle(event: Record<string, string>): void {
        const fieldForm = form.find((field) => field.name === event.name);
        const val = event.value.split('.').join('');
        if (fieldForm && val.length) {
            if (Number(val) > lenderSummary.cashBalance) {
                fieldForm.apiErrorMessage = `Jumlah cash balance saat ini ${rupiahCurrencyFormatter(lenderSummary.cashBalance)}`;
                setInvalid(true);
                setFullFunding(false);
            } else if (Number(val) < selectedItem.data.minimumFunding) {
                fieldForm.apiErrorMessage = `Minimum jumlah pendanaan adalah ${rupiahCurrencyFormatter(selectedItem.data.minimumFunding)}`;
                setInvalid(true);
                setFullFunding(false);
            } else if (Number(val) > selectedItem.data.outstandingFunding) {
                fieldForm.apiErrorMessage = `Jumlah pendanaan maksimal adalah ${rupiahCurrencyFormatter(selectedItem.data.outstandingFunding)}`;
                setInvalid(true);
                setFullFunding(false);
            } else if (
                (selectedItem.data.outstandingFunding - Number(val)) < selectedItem.data.minimumFunding
                && Number(val) !== selectedItem.data.outstandingFunding
            ) {
                fieldForm.apiErrorMessage = `Sisa pendanaan tidak boleh kurang dari ${rupiahCurrencyFormatter(selectedItem.data.minimumFunding)}`;
                setInvalid(true);
                setFullFunding(false);
            } else if (Number(val) === selectedItem.data.outstandingFunding) {
                fieldForm.apiErrorMessage = '';
                setInvalid(false);
                setFullFunding(true);
            } else {
                fieldForm.apiErrorMessage = '';
                setInvalid(false);
                setFullFunding(false);
            }
            const updateForm = [
                ...form
            ];
            setForm(updateForm);
            fieldForm.value = event.value;
        } else if (fieldForm && !val.length) {
            fieldForm.apiErrorMessage = '';
            setInvalid(true);
            setFullFunding(false);
        }
    }

	const handleChangeCheckbox = (e) : void => {
		if (e.target.checked === true) {
			setDisableButtonAgreement(false);
		} else {
			setDisableButtonAgreement(true);
		}
	};

	function fundingModal(): React.ReactElement {
        return (
            <div>
                <Modal
                    isOpen={isModalFundingOpen}
                    ariaHideApp={false}
                    style={customModalStyles}
                >
                    <div className="titleContainer">
                        <h3> Jumlah Funding </h3>
                        <button
                            className="imageContainer btn"
                            type="button"
                            disabled={fundingLoading}
                            onClick={() => closeFundingModal()}
                        >
                            <img src={ImagePath.close.src} alt={ImagePath.close.alt} />
                        </button>
                    </div>
                    <div className="d-flex justify-content-space-between align-items-center">
                        {renderPercentageLoanTypeText(
                            selectedItem.data.interestPercentage,
                            selectedItem.data.loanTypeName
                        )}
                    </div>
                    <div className="d-flex flex-wrap mt-2">
						{selectedItemFunding.textLabel.map((each: ITextLabel, index: number) => (
							each.title === "Keterangan Pinjaman" ? (
							<div className="w-40" key={`${each.title}`}>
								{renderTextLabel(each, index)}
							</div>
							) : (
								<div className="w-30" key={`${each.title}`}>
								{renderTextLabel(each, index)}
								</div>
							)
                        ))}
                    </div>
                    <div className="mt-2">
                        {
                            renderFundingProgressBar(selectedItem)
                        }
                    </div>
                    <div className="d-flex toggle-wrapper">
                        <Toggle
                            disabled={fundingLoading}
                            checked={isFullFunding}
                            icons={false}
                            onChange={(event) => onToggleChange(event.target.checked)}
                        />
                        <span>Danai Semua</span>
                    </div>
                    <div>
                        <form onSubmit={onHandleSubmitFunding}>
                            {form.map((each) => (
                                <InputComponent
                                    disabled={fundingLoading}
                                    key={each.id}
                                    id={each.id}
                                    formType={each.formType}
                                    placeholder={each.placeholder}
                                    name={each.name}
                                    apiErrorMessage={each.apiErrorMessage}
                                    value={each.value}
                                    onChange={(event) => { onChangeHandle(event); }}
                                />
                            ))}
                            <Button
                                buttonText="Selanjutnya"
                                disabled={fundingLoading || Boolean(urlLoanAgreement) ? true : invalid}
                                loading={fundingLoading}
                            />
                        </form>
                    </div>
                </Modal>
            </div>
        );
    }

	function agreementModal(): React.ReactElement {
		const headerStyling = {
			paddingBottom: '40px',
		};
		const buttonStyling = {
			width: '464px',
			margin: '0 auto'
		};
		const checkboxStyling = {
			marginRight: '19px',
		};
		return (
			<div>
				<Modal
					isOpen={isModalAgreementOpen}
					ariaHideApp={false}
					style={modalDocument}
				>
					<div className="titleContainer" style={headerStyling}>
						<h3>Preview Agreement</h3>
						<button
							className="imageContainer btn"
							type="button"
							disabled={fundingLoading}
							onClick={() => closeAgreementModal()}
						>
							<img src={ImagePath.close.src} alt={ImagePath.close.alt} />
						</button>
					</div>
                    {renderTabComponent()}
					{renderPDWViewer()}
					<div>
						<input type="checkbox" id="agreement" style={checkboxStyling} onChange={handleChangeCheckbox} disabled={disableCheckBoxAgreement} />
						<span>Saya telah membaca dan menyetujui </span>
						<button type="button" id="tnc_link" onClick={() => handleTnc()}>Syarat & Ketentuan</button>
						<span> yang berlaku</span>
					</div>
					<div style={buttonStyling}>
						<form onSubmit={onHandleSubmitAgreement}>
							<Button
                                disabled={disableButtonAgreement ? true : invalid}
								buttonText={fundingLoading ? "Proses Pendanaan" : "Danai"}
                                loading={fundingLoading}
							/>
						</form>
					</div>
				</Modal>
			</div>
		);
	}

    return (
        <>
            <div className="card funding-card">
                {renderTopContainer(marketplaceTextLabel)}
                {renderBottomContainer(marketplaceTextLabel)}
            </div>
            {fundingModal()}
			{agreementModal()}
        </>
    );
};

export default MarketplaceCard;
